import { ref } from 'vue'
import { defineStore } from 'pinia'
import {
  higherLeague,
  isLeagueId,
  leagueOfFrame,
  leagueOfMat,
  leagueOfSleeve,
  leagueReached,
  type LeagueId,
} from '@shared/index'

export const useLeagueRewardsStore = defineStore('leagueRewards', () => {
  const peak = ref<LeagueId | null>(null)

  function reached(league: LeagueId | null): boolean {
    if (!league) return true
    return import.meta.env.DEV || leagueReached(peak.value, league)
  }

  function apply(raw: unknown): void {
    peak.value = isLeagueId(raw) ? raw : null
  }

  /** A duel result can only raise the peak. */
  function raise(league: LeagueId | null | undefined): void {
    if (league) peak.value = higherLeague(peak.value, league)
  }

  function clear(): void {
    peak.value = null
  }

  return {
    peak,
    reached,
    sleeveUnlocked: (id: string) => reached(leagueOfSleeve(id)),
    matUnlocked: (id: string) => reached(leagueOfMat(id)),
    frameUnlocked: (id: string) => reached(leagueOfFrame(id)),
    apply,
    raise,
    clear,
  }
})
